import { render, staticRenderFns } from "./TechTransfer.vue?vue&type=template&id=12fe2ba8&"
import script from "./TechTransfer.vue?vue&type=script&lang=js&"
export * from "./TechTransfer.vue?vue&type=script&lang=js&"
import style0 from "./TechTransfer.vue?vue&type=style&index=0&id=12fe2ba8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports